<template>
  <BaseButton
    text
    color="white"
    retain-focus-on-click
    :ripple="false"
    :class="isDisabled ? 'disabled-icon' : ''"
    @click="searchHandler()"
  >
    <BaseSpriteIcon icon-name="ico-search"></BaseSpriteIcon>
    <span class="context-menu-text-item">{{ $t('Context.short.search') }}</span>
  </BaseButton>
</template>

<script>
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';
import BaseButton from '@/components/base/BaseButton/BaseButton';

import AppStateEnum from '@/enums/AppStateEnum';
import Locator from '@shared/publication/locator.mjs';
import TextUtils from '@shared/publication/dom-utils/text-utils.mjs';

const MAX_SELECTED_WORDS_FOR_SEARCH = 10;

export default {
  name: 'SearchControl',
  components: {
    BaseSpriteIcon,
    BaseButton
  },
  data() {
    return {
      isDisabled: false,
      copyText: ''
    };
  },
  computed: {
    selectedLocator() {
      return this.$store.getters['MaterialsStore/getSelectedLocator'];
    },
    isOnline() {
      return this.$store.getters['ContextStore/isOnline'];
    }
  },
  watch: {
    selectedLocator: {
      immediate: true,
      handler() {
        this.getCopyText();
      }
    }
  },
  methods: {
    async getCopyText() {
      if (!this.selectedLocator) {
        return;
      }
      const copyRange = Locator.deserialize(this.selectedLocator.toJSON());
      this.copyText = TextUtils.extractContentByRangeLocator(copyRange);
      this.isDisabled = this.checkIsDisabled(copyRange);
    },
    checkIsDisabled(copyRange) {
      if (!this.isOnline) {
        return true;
      }
      const isSamePara =
        copyRange.startLocator.paragraphId === copyRange.endLocator.paragraphId;
      if (!isSamePara) {
        return true;
      }
      const lang = this.$store.getters['BookStore/getParaLanguage'](
        copyRange.startLocator.prefixedParagraphId
      );
      return !TextUtils.validateTtsText(this.copyText, lang, {
        maxWordsNumber: MAX_SELECTED_WORDS_FOR_SEARCH
      }).valid;
    },
    searchHandler() {
      if (!this.isDisabled && this.copyText) {
        this.$store.commit('SwSearchStore/setShouldTriggerInput', false);
        this.$store.dispatch('SwSearchStore/setSearchText', this.copyText);
        this.$router.push({ name: AppStateEnum.SEARCH });
      }
    }
  }
};
</script>
